import type { SearchMatches } from 'widgets/sports-menu-widget/model/types';

import { ResultGroup } from '../ResultGroup';

import { TXTWCL_Competitions } from './CompetitionsResultGroup.messages.json';

interface Props {
  competitions: SearchMatches['competitions'];
}
export const CompetitionsResultGroup = ({ competitions }: Props) => (
  <ResultGroup resultsGroup={competitions} titleTranslationTag={TXTWCL_Competitions} />
);
